import css from 'styled-jsx/css';

export default css`
  .SiteHeader {
    background-color: #fff;
  }
`;
